export const config = {
	status: {
		'0': '成功'
	}
}



// WEBPACK FOOTER //
// ./src/api/config.js